import React from 'react';
import styled from 'styled-components';
import {
  SectionContainer,
  SectionTextContainer,
} from '../../../aboutUs/styles';
import { COLORS, device } from '../../../../constants';
import { Box, Title, VerticalBox } from '../../../../components';
import { Expertises } from '../../../../types/globalTypes';
import { useTranslation } from 'react-i18next';
import { ExpertiseElement } from '../../../../components/Expertise/ExpertiseElement';
import { MotionYOffsetBlock } from '../../../../components/Motion';

interface DivProps extends React.HTMLProps<HTMLDivElement> {
  expertises: Expertises[];
}

export const ProjectExpertises: React.FC<DivProps> = ({
  expertises,
  ...props
}) => {
  const { t } = useTranslation();

  return (
    <SectionContainer $color={COLORS.LIGHT_BG_COLOR}>
      <Box>
        <VerticalBox>
          <SectionTextContainer $gap={80}>
            <Title title={t('screen.project.expertises')} isAnimated={true} />
            <ExpertisesContainer {...props}>
              {expertises &&
                expertises.map(el => (
                  <ExpertiseElement key={el._id} title={el.Name} />
                ))}
            </ExpertisesContainer>
          </SectionTextContainer>
        </VerticalBox>
      </Box>
    </SectionContainer>
  );
};

const ExpertisesContainer = styled(MotionYOffsetBlock)`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, auto));
  column-gap: 100px;
  row-gap: 48px;
  background-color: ${COLORS.GRAY_BG_COLOR};
  padding: 40px;
  @media screen and (${device.lg}) {
    column-gap: 48px;
  }
  @media screen and (${device.md}) {
    column-gap: 20px;
    row-gap: 10px;
  }
`;
